/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

let $ = jQuery;
import {
	OKEVENT,
	triggerOkEvent,
	subscribeToOkEvent,
} from "shared/util/OkEventHelpers";


// ==============================================================================
// Shared Dom Library
// ------------------------------------------------------------------------------

let HeaderBarDom = {
	init() {
		this.bar = $("#navigation");
		this.page = $("#page");
		this.window = $(window);
		this.document = $(document);
		this.user = this.bar.find(".nav-user");
		this.user_toggle = this.bar.find(".nav-user-image");
		this.user_menu_class = "nav-user-menu";
		this.user_menu = this.bar.find(`.${this.user_menu_class}`);
		return (this.body = $("body"));
	},
};


// ==============================================================================
// Header Bar (externally accessible)
// ------------------------------------------------------------------------------

const HeaderBar = {
	barFixed: false,
	stickyable: true,
	pagetop: 0,
	barleft: 0,
	isPositioning: false,
	isRefreshingPageSize: false,

	init(param) {
		// init the dom elements and install a shortcut to it
		if (param == null) {
			param = {};
		}
		let { incognito } = param;
		HeaderBarDom.init();
		this.Dom = HeaderBarDom;

		this.minwidth = this.Dom.bar.css("min-width");
		this.minwidth = parseInt(this.minwidth, 10);

		// these functions checks the page position only if it hasn't
		// been checked recently
		this.refreshPagePosition();
		this.refreshPageSize();

		this.position();

		// init tooltips. bind them to the headerbar singleton so that other
		// services can access them.
		this.iconTooltips = IconTooltips;
		this.iconTooltips.init();

		// init user menu
		HeaderBarUserMenu.init();

		// init incognito, if we got it
		if (
			incognito &&
			(incognito != null ? incognito.activated : undefined) != null
		) {
			incognito.newTemplate = true;
			IncognitoSwitch.init(incognito);
		}

		return this.listen();
	},

	listen() {
		// position the header on scroll
		return this.Dom.window.on("scroll resize focus", ev => {
			if (
				(ev != null ? ev.type : undefined) === "resize" ||
				(ev != null ? ev.type : undefined) === "focus"
			) {
				this.refreshPageSizeWhenReady();
			}
			this.positionWhenReady();
			return true;
		});
	},

	refreshPageSizeWhenReady() {
		if (this.isRefreshingPageSize) {
			return;
		}
		this.isRefreshingPageSize = true;
		return window.requestAnimationFrame(() => {
			this.refreshPageSize();
			return (this.isRefreshingPageSize = false);
		});
	},

	positionWhenReady() {
		if (this.isPositioning) {
			return;
		}
		this.isPositioning = true;
		return window.requestAnimationFrame(() => {
			this.position();
			return (this.isPositioning = false);
		});
	},

	position() {
		this.refreshPagePosition();
		if (!this.stickyable) {
			return;
		}
		let scrolltop = this.Dom.window.scrollTop();
		let left = this.Dom.window.scrollLeft();

		if (scrolltop >= this.pagetop) {
			if (!this.barFixed) {
				this.barFixed = true;
				this.Dom.bar.addClass("fixed");

				triggerOkEvent(OKEVENT.HeaderbarPosition, {
					position: "fixed",
				});
			}
		} else {
			if (this.barFixed) {
				this.barFixed = false;
				this.Dom.bar.removeClass("fixed");

				triggerOkEvent(OKEVENT.HeaderbarPosition, {
					position: "absolute",
				});
			}
		}

		if (!this.barFixed) {
			left = 0;
		}

		// scroll the bar if the window width is less than the content width
		if (this.barleft !== left && this.contentWidth > this.windowWidth) {
			let update = {
				left: -left,
			};
			this.Dom.bar.css("left", -left);
			return (this.barleft = left);
		}
	},

	toggleStickyable(force) {
		let stickyable = !this.stickyable;
		if (force != null) {
			stickyable = !!force;
		}
		this.stickyable = stickyable;
		if (this.stickyable) {
			return this.position();
		} else {
			this.barFixed = false;
			// This might get called reeeeal early, so let's make sure.
			return __guard__(this.Dom != null ? this.Dom.bar : undefined, x =>
				x.removeClass("fixed")
			);
		}
	},

	// if we're adding a new header above the headerbar,
	// we don't want it to be fixed.
	// (otherwise, the headerbar will be above that new shit.)
	// so unfix the bar if that's about to blow.
	prepareForNewHeader() {
		if (!this.barFixed) {
			return;
		}
		this.barFixed = false;
		return this.Dom.bar.removeClass("fixed");
	},

	refreshPagePosition() {
		let offset = this.Dom.page.offset();
		return (this.pagetop = offset.top);
	},

	refreshPageSize() {
		this.windowWidth = this.Dom.window.width();
		return (this.contentWidth =
			parseInt($("#page").css("minWidth"), 10) || $("#page").width());
	},
};

// ==============================================================================
// Icon Tooltips
// ------------------------------------------------------------------------------

var IconTooltips = {
	init() {
		this.Dom = HeaderBarDom;
		this.tooltip = new OkTooltip({
			id: "nav-notifications-tooltip",
			message: "",
			direction: "bottom",
			target: this.Dom.bar,
			classes: "small",
			padding: -10,
			delay: false,
		});

		// holds a timeout so we don't immediately close when you get off
		this.closer = null;
		return this.listen();
	},

	listen() {
		this.Dom.bar
			.on("mouseover", ".nav-notifications-item > a", ev => {
				let target = $(ev.currentTarget);
				return this.openTooltip(target);
			})
			.on("mouseout", ".nav-notifications-item > a", ev => {
				return this.closeTooltip();
			});

		return subscribeToOkEvent(OKEVENT.MessagesDropdownOpen, e => {
			return this.closeTooltipNow();
		});
	},

	openTooltip(target) {
		if (HeaderBarUserMenu.user_menu_opened) {
			return;
		}

		clearTimeout(this.closer);
		let text = target.find(".text").text();
		this.tooltip.changeTarget(target);
		this.tooltip.changeMessage(text);
		return this.tooltip.open();
	},

	closeTooltip() {
		return (this.closer = setTimeout(() => {
			return this.closeTooltipNow();
		}, 100));
	},

	closeTooltipNow() {
		return this.tooltip.close();
	},
};

// ==============================================================================
// User Menu
// ------------------------------------------------------------------------------

window.HeaderBarUserMenu = {
	init() {
		this.Dom = HeaderBarDom;
		this.user_menu_opened = false;

		return this.listen();
	},

	listen() {
		// open on toggle
		this.Dom.user_toggle.on("click tap", ev => {
			ev.preventDefault();

			if (this.user_menu_opened) {
				this.close();
			} else {
				this.open();
			}

			return false;
		});

		// close when you hit anything else
		return this.Dom.body.on("click tap", ev => {
			let target = $(ev.target);
			this.dismiss(target);
			return true;
		});
	},

	open() {
		if (this.user_menu_opened) {
			return;
		}
		this.user_menu_opened = true;
		IconTooltips.closeTooltipNow();
		this.Dom.user.addClass("nav-user-menu-shown");
		this.Dom.document.trigger("headerbar.usermenu.open");
	},

	// close the user menu, only if it's open and they didn't click on it
	dismiss(target) {
		if (!this.user_menu_opened) {
			return;
		}
		if (target.closest(`.${this.Dom.user_menu_class}`).length) {
			return;
		}
		if (Limelight.isOpen) {
			return;
		}

		return this.close();
	},

	close() {
		if (!this.user_menu_opened) {
			return;
		}
		this.user_menu_opened = false;
		this.Dom.user.removeClass("nav-user-menu-shown");
		return this.Dom.document.trigger("headerbar.usermenu.close");
	},
};

function __guard__(value, transform) {
	return typeof value !== "undefined" && value !== null
		? transform(value)
		: undefined;
}

window.HeaderBar = HeaderBar;

export default HeaderBar;



// WEBPACK FOOTER //
// ./src/legacy/headerbar.js